import { useSelector } from 'react-redux';

import useAnalytics from '~/hooks/useAnalytics/useAnalytics';
import { useQuery } from '~/hooks/useQuery';
import { useRouter } from '~/hooks/useRouter';
import { RootState } from '~/store';
import { IEcosystem } from '~/types/interfaces/ecosystem';

export const useEcosystemDownloadFilesController = () => {
  const { params } = useRouter();
  const { track } = useAnalytics();

  const ecosystemId = params?.ecosystemId;

  // Get ecosystem and organization data from Redux store
  const selectedEcosystem = useSelector(
    (state: RootState) => state.ecosystem.selectedEcosystem,
  );
  const selectedUserProfile = useSelector(
    (state: RootState) => state.auth.selectedUserProfile,
  );

  const { data: ecosystem, isLoading } = useQuery<IEcosystem>(
    `ecosystem/${ecosystemId}`,
    {
      queryOptions: {
        enabled: !!ecosystemId,
      },
    },
  );

  const downloadableFiles = ecosystem?.downloadableFiles || [];

  const handleDownloadFile = (link: string, fileName: string) => {
    try {
      const a = document.createElement('a');
      a.href = link;
      a.download = '';
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // Prepare tracking data with complete identifiers
      const ecosystem_id =
        selectedEcosystem?._id || selectedUserProfile?.ecosystem || ecosystemId;
      const ecosystem_name =
        selectedEcosystem?.name ||
        selectedUserProfile?.ecosystemSummary?.name ||
        ecosystem?.name;
      const org_id = selectedUserProfile?.organization;
      const org_name = (selectedUserProfile?.userOrganization as any)?.name;

      // Build tracking data ensuring required fields are always present
      const trackingData: any = {
        file_name: fileName,
        file_url: link,
      };

      // Add optional fields only if they have values
      if (ecosystem_id) trackingData.ecosystem_id = ecosystem_id;
      if (ecosystem_name) trackingData.ecosystem_name = ecosystem_name;
      if (org_id) trackingData.org_id = org_id;
      if (org_name) trackingData.org_name = org_name;

      track('file_download', trackingData);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  return { isLoading, downloadableFiles, handleDownloadFile };
};
